var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm._transition}},[_c('div',_vm._b({directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],class:_vm._classNames},'div',_vm._attributes,false),[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }